window.addEventListener('DOMContentLoaded', function() {
    'use strict';

    // Slider
    const myCarousel = new Carousel(document.querySelector("#carousel"), {
        Dots: false,
        Navigation: false,
    });

    const slides = document.querySelectorAll('.carousel__slide'),
          toogleSlide = document.querySelectorAll('.toggle__item');

    for (let i = 0; i < slides.length; i++) {
        toogleSlide[i].addEventListener('click', function() {
            const toogleSlideCurrent = document.querySelector('.toggle__item.active');
            toogleSlideCurrent.classList.remove('active');
            myCarousel.slideTo(i);
            toogleSlide[i].classList.add('active');
        });
    }


    // Cards
    const cardsContainer = document.querySelector('.cards__list');

    fetch('https://jsonplaceholder.typicode.com/posts?_start=0&_end=10')
    .then((response) => response.json())
    .then(function (data) { 
        // console.log(data);

        for (let i = 0; i < data.length; i++) {
            let userId = data[i].userId,
                id = data[i].id,
                body = data[i].body,
                title = data[i].title;
            
            let newCard = document.createElement('div');
            newCard.className = "cards__item";
            newCard.setAttribute('data-postid', id);
            // newCard.id = id;
            newCard.innerHTML =             
                `<img class="cards__image" src="images/card-${id}.jpg" alt="image-${i}">
                    <div class="cards__inner">
                        <div class="cards__text-block">
                            <h3 class="cards__title">${title}</h3>
                            <p class="cards__subtitle">${title}</p>
                            <p class="cards__text">${body}</p>
                            <p class="cards__copyright">Posted by Eugenia, on July  24, 2019 ${userId}</p>
                        </div>
                        <a class="cards__link" href="${id}">Continue reading</a>
                    </div>
                `;
            cardsContainer.append(newCard);
        }
    });

    const btnLoadMore = document.getElementById('loadmore');

    btnLoadMore.addEventListener('click', function() {

        const cardsItem = document.querySelectorAll('[data-postid]');

        if (cardsItem.length > 0) {
            const lastCardsItemPostId = Number(cardsItem[cardsItem.length - 1].getAttribute('data-postid'));
            // console.log(lastCardsItemPostId + 6);
    
            fetch(`https://jsonplaceholder.typicode.com/posts?_start=${lastCardsItemPostId}&_end=${lastCardsItemPostId + 6}`)
            .then((response) => response.json())
            .then(function (data) { 
                // console.log(data);
    
                for (let i = 0; i < data.length; i++) {
                    let userId = data[i].userId,
                        id = data[i].id,
                        body = data[i].body,
                        title = data[i].title;
                    
                    let newCard = document.createElement('div');
                    newCard.className = "cards__item";
                    newCard.setAttribute('data-postid', id);
                    newCard.innerHTML =             
                        `<img class="cards__image" src="images/card-1.jpg" alt="image-${i}">
                            <div class="cards__inner">
                                <div class="cards__text-block">
                                    <p class="cards__title">${title}</p>
                                    <p class="cards__subtitle">${title}</p>
                                    <p class="cards__text">${body}</p>
                                    <p class="cards__copyright">${userId}</p>
                                </div>
                                <a class="cards__link" href="${id}">Continue reading</a>
                            </div>
                        `;
                    cardsContainer.append(newCard);
                }
            });
        }
    });


    // Form
    const formInput = document.querySelectorAll('.form__input, .form__textarea');

    for (let i = 0; i < formInput.length; i++) {
        formInput[i].addEventListener('focus', function() {
            formInput[i].classList.add('active');
        });
        formInput[i].addEventListener('blur', function() {
            if (formInput[i].value === '') {
                formInput[i].classList.remove('active');
            }
        });
    }

    // Form validate
    const form = document.getElementById('form'),
          formName = document.getElementById('name'),
          formEmail = document.getElementById('email'),
          formPhone = document.getElementById('phone'),
          formMessage = document.getElementById('formtext');

    formName.addEventListener('input', function() {
        this.value = this.value.replace(/[^a-zа-яё\s]/gi, '');
    });
    
    formName.addEventListener('blur', function() {
        this.value = this.value.trim();
        checkLength(this.value.length, this);
    });

    formEmail.addEventListener('blur', function() {
        checkEmail(this.value, this);
    });

    function checkLength(inputLength, input) {
        const inputParent = input.parentNode,
              error = inputParent.querySelector('.error-text');
        
        if ( ! error && inputLength <= 1 ) {
            const message = ((inputLength === 1)) ? 'Имя должно быть не короче 2 символов' : '';
            input.classList.add('error');

            const error = document.createElement('span');
            error.classList.add('error-text');
            error.innerHTML = message;
            input.parentNode.appendChild(error);
        }
        if ( error && inputLength > 1 ) {
            input.classList.remove('error');
            input.parentNode.removeChild(error);
        }
    }

    function checkEmail(inputValue, input) {
		const pattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/gm,
              inputParent = input.parentNode,      
              error = inputParent.querySelector('.error-text');
		
        if ( ! error && ! inputValue.match(pattern)) {
            const message = 'Введите действительный адрес электронной почты';
            input.classList.add('error');
            
            const error = document.createElement('span');
            error.classList.add('error-text');
            error.innerHTML = message;
            input.parentNode.appendChild(error);
		}
        if ( error && inputValue.match(pattern) ) {
            input.classList.remove('error');
            input.parentNode.removeChild(error);
        }
	}

    // Проставление маски на полe ввода телефона
    (function (){
		let code = '+7',
			find = /\+7/;
		code = '+7';
		find = /\+7/;

		formPhone.addEventListener('focus', function() {
			this.value = code + ' ' + this.value.replace(code + ' ', '');
		});
		formPhone.addEventListener('input', function() {
			let val = this.value.replace(find, ''),
				res = code + ' ';
			val = val.replace(/[^0-9]/g,'');

			for (let i = 0; i < val.length; i++){
				res += i === 0 ? '(' : '';
				res += i == 3 ? ') ' : '';
				res += i== 6 || i == 8 ?' ' : '';
				if(i == 10) break;
				res += val[i];
			}
			this.value = res;
		});
		formPhone.addEventListener('blur', function() {
			let val = this.value.replace(find,'');
			val = val.trim();
			if (!val) this.value = null;
		});
	})();

    formMessage.addEventListener('blur', function() {
        const inputParent = this.parentNode,      
              error = inputParent.querySelector('.error-text');
  
        if ( this.value === '' ) {
            const message = 'Введите свой вопрос';
            this.classList.add('error');
            
            const error = document.createElement('span');
            error.classList.add('error-text');
            error.innerHTML = message;
            this.parentNode.appendChild(error);
        }
        if ( this.value !== '' ) {
            this.classList.remove('error');
            this.parentNode.removeChild(error);
        }
    });

    // Отправка формы
    form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (document.querySelector('.error-text') || formName.value === '' || formEmail.value === '' || formMessage.value === '') {
            return false;
        }

        const data = new FormData(this);
        // console.log(data);

        fetch('/request.php', {
            method: 'POST',
            data: 'data',
        })
        .then((response) => {
            // console.log(response);
            form.reset();

            const fancybox = new Fancybox([
                {
                  src: "<p>Форма отправлена</p>",
                  type: "html",
                },
            ]);
        })
        .then(function(data) {

        });
    });

    const formClose = document.querySelector('.form__close');
    formClose.addEventListener('click', function() {
        Fancybox.close();
    });

    // Мобильное меню
    const hamburger = document.querySelector('.hamburger'),
          menu = document.querySelector('.menu');

    hamburger.addEventListener('click', function() {
        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            menu.classList.remove('open');
        } else {
            hamburger.classList.add('active');
            menu.classList.add('open');
        }
    });

    
});